import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar'
import { Button } from '../../core'
import { styled } from '../../styles'

const StyledActionBar = styled('div')(({ theme }) => ({
  padding: 12,
  display: 'flex',
  justifyContent: 'flex-end',
}))

export const CustomActionBar = ({ onAccept }: PickersActionBarProps) => {
  return (
    <StyledActionBar>
      <Button onClick={onAccept} variant="contained" color="secondary">
        Confirm
      </Button>
    </StyledActionBar>
  )
}
